import type { TableCommandFactory } from 'components/Table/model/TableModel';
export const requestReload: TableCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    draft.dataRequestNumber++;
  });
};
